import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  VStack,
  Text,
  Link,
  Box,
  Divider,
  Flex,
} from '@chakra-ui/react';

interface SiteInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onShowInfoOverlay: () => void;
}

const SiteInfoModal: React.FC<SiteInfoModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody pt={8} pb={6}>
          <VStack spacing={4} align="stretch">
            <Text>
              Hello, I&apos;m Neil. 👋🏼
            </Text>
            <Text>
            I made this because I was sick of having to open up a DAW just to compare mixes and masters. Now I can listen in the car, at home, on other people&apos;s systems... Some of my friends thought it was totally pointless, but most thought it was pretty useful, so I hope you will too.
            </Text>

            <Divider />
            
            <Box>
              <VStack spacing={2} align="stretch">
                <Text fontSize="sm">
                  <strong>Privacy:</strong> Your audio files are processed locally in your browser. When sharing setups, file URLs become part of the share link. Only share with people you trust.
                </Text>
                <Text fontSize="sm">
                  <strong>Terms:</strong> By using ABmyMix, you agree to use it lawfully and respect intellectual property rights. You retain ownership of your audio files.
                </Text>
                <Flex gap={4} mt={3} justify="center">
                  <Link 
                    href="/privacy" 
                    color="blue.400" 
                    fontSize="sm"
                    _hover={{ textDecoration: 'underline' }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Full Privacy Policy
                  </Link>
                  <Link 
                    href="/terms" 
                    color="blue.400" 
                    fontSize="sm"
                    _hover={{ textDecoration: 'underline' }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Service
                  </Link>
                </Flex>
              </VStack>
            </Box>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SiteInfoModal; 